/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import * as actionTypes from './actionTypes';

const initialState = {
  performDisputeResolutionObj: {},
  disputeResolutionDetailObj: {},
  disputedClaimsDetailsObj: {},
  planType: [],
  rebateProgram: [],
  quarter: '',
  errorMsgPerDisRes: [],
  mfgDataForGrid: [],
  displayCurrentDispute: [],
  setDisplayCurrentDisputes: {
    pageCount: 1,
    disputesList: [],
  },
  setDisputedClaimsDetail: {},
  setNdcActivityHistory: {},
  setProviderSummaryAndGrid: {},
  setProviderHeader: {},
  setNDCHistoryHeader: {},
  setClaimsHeader: {},
  getStrength: '',
  updateProviderSummarySave: '',
  providerSummaryGridList: [],
  claimDetailFullScrren: false,
  currentDisputesFullScreen: false,
  requestScrrenMfgFullScreen: false,
  saveCancelClaimsDetail: true,
  providerGridFullScrren: false,
  ndcHistoryGridFullScrren: false,
  providerSummTabObj: {},
  providerSummaryGrid: [],
  providerSummaryGridObj: {},
  selectedRowData: {},
  saveClaimDetailResponse: {},
  saveClaimDetailError: [],
  displayCurrentDisputeError: [],
  invoiceDetail: {},
  sumCount:''
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CURRENT_DISPUTE_DISPLAY_OBJ:
      return { ...state, performDisputeResolutionObj: action.screenData };
    case actionTypes.GET_PROVIDER_SUMMARY_GRID:
      return { ...state, providerSummaryGrid: action.payload };
    case actionTypes.GET_PROVIDER_SUMMARY_GRID_OBJ:
      return { ...state, providerSummaryGridObj: action.payload };
    case actionTypes.GET_INVOICE_DETAIL:
      return { ...state, invoiceDetail: action.payload };
    case actionTypes.DISPUTE_CURRENT_DISPUTE_ERROR:
      return { ...state, displayCurrentDisputeError: action.payload };
    case actionTypes.GET_CURRENT_DISPUTE_DISPLAY_DETAIL_OBJ:
      return { ...state, disputeResolutionDetailObj: action.detailScrData };
    case actionTypes.GET_DISPUTED_CLAIMS_DETAIL_OBJ:
      return {
        ...state,
        disputedClaimsDetailsObj: action.payload,
      };
    case actionTypes.GET_ERROR_MSG_PERFORM_DISPUTE_RESOL:
      return { ...state, errorMsgPerDisRes: action.payload };
    case actionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };
    case actionTypes.GET_REBATE_PROGRAM:
      return { ...state, rebateProgram: action.payload };
    case actionTypes.GET_QUARTER_VALUE:
      return { ...state, quarter: action.payload };
    case actionTypes.GET_MANUFACTURER_GRID_DATA:
      return { ...state, mfgDataForGrid: action.payload };
    case actionTypes.GET_DISPLAY_CURRENT_DIPUTES_HEADER_AND_GRID:
      return { ...state, displayCurrentDispute: action.payload };
    case actionTypes.SET_DISPLAY_CURRENT_DISPUTES:
      return { ...state, setDisplayCurrentDisputes: action.payload };
    case actionTypes.SET_DISPUTED_CLAIMS_DETAIL:
      return { ...state, setDisputedClaimsDetail: action.payload };
    case actionTypes.SET_NDC_ACTIVITY_HISTORY:
      const setNdcHistryObj = action?.payload;
      if (setNdcHistryObj) {
        if (
          setNdcHistryObj?.ndcactivityHistory &&
          setNdcHistryObj?.ndcactivityHistory?.length > 0
        ) {
          setNdcHistryObj.ndcactivityHistory.forEach((element) => {
            if (element.drugActivityDt) {
              element.drugActivityDt = moment(element?.drugActivityDt).format(
                'MM/DD/YYYY'
              );
            }
            element.changeAmt = `$ ${element?.changeAmt}`;
            element.unitRebateAmt = ` ${
              element.unitRebateAmt
                ? parseFloat(element.unitRebateAmt).toFixed(4)
                : 0
            } `;
            element.numOfUnits = `${
              element.numOfUnits ? parseFloat(element.numOfUnits).toFixed(4) : 0
            } `;
            element.changeNumOfUnits = element.changeNumOfUnits
              ? element.changeNumOfUnits.toFixed(4)
              : '0.0000';
          });
        }
      }
      return { ...state, setNdcActivityHistory: setNdcHistryObj };
    case actionTypes.SET_PROVIDER_SUMMARY_REQ_HEADER:
      return { ...state, setProviderHeader: action.payload };
    case actionTypes.PROVIDER_SUMMARY_GRID_LIST:
      return {
        ...state,
        providerSummaryGridList: action.providerSummaryGridList,
      };
    case actionTypes.SET_CLAIMS_DETAIL_REQ_HEADER:
      return { ...state, setClaimsHeader: action.payload };
    case actionTypes.SET_NDC_HISTORY_REQ_HEADER:
      return { ...state, setNDCHistoryHeader: action.payload };
    case actionTypes.SET_PROVIDER_SUMMARY_HEADER_AND_GRID:
      return { ...state, setProviderSummaryAndGrid: action?.payload };
    case actionTypes.GET_STRENGTH_DESCR:
      return { ...state, getStrength: action.payload };
    case actionTypes.DISPUTED_CLAIMS_DETAILS_SAVE:
      return { ...state, saveClaimDetailResponse: action.payload };
    case actionTypes.DISPUTED_CLAIMS_DETAILS_ERROR:
      return { ...state, saveClaimDetailError: action.payload };
    case actionTypes.UPDATE_PROVIDER_SUMMARY_SAVE:
      return { ...state, updateProviderSummarySave: action.payload };
    case actionTypes.FULLSCREEN_SUMM_PRO_GRID:
      return {
        ...state,
        providerGridFullScrren: action.payload,
      };
    case actionTypes.FULLSCREEN_CURRENT_DISPUTES_GRID:
      return {
        ...state,
        currentDisputesFullScreen: action.payload,
      };
    case actionTypes.FULLSCREEN_CLAIM_DETAIL_GRID:
      return {
        ...state,
        claimDetailFullScrren: action.payload,
      };
    case actionTypes.FULLSCREEN_NDC_HISTORY_GRID:
      return {
        ...state,
        ndcHistoryGridFullScrren: action.payload,
      };
    case actionTypes.FULLSCREEN_REQUEST_MFG_GRID:
      return {
        ...state,
        requestScrrenMfgFullScreen: action.requestScreen,
      };
    case actionTypes.PROVIDER_SUMM_TAB_DATA:
      return {
        ...state,
        providerSummTabObj: action.payload,
      };
    case actionTypes.SAVE_CANCEL_CLAIM_DETAIL:
      return {
        ...state,
        saveCancelClaimsDetail: action.payload,
      };
    case actionTypes.SELECTED_ROW_IN_MFG_GRID:
      return {
        ...state,
        selectedRowData: action.payload,
      };
    case actionTypes.SUM_OF_COUNT:    
      return {    
          ...state,    
          sumCount: action.payload,   
      };  
    default:
      return state;
  }
};
export default reducer;
